import { Seo } from "./models/Seo";

export const AUTH_TOKEN = "codealo_io_token";
export const YT_URL =
  "https://www.youtube.com/channel/UCLdBO2AVbCohANbEtEHn1CA?sub_confirmation=1";

export const DEFAULT_SEO_HEAD: Seo = {
  id: null,
  keywords: "programacion,code,codealo,educacion,aprender",
  metaTitle: "Codealo",
  metaDescription: "La red social para programadores de habla hispana",
  preventIndexing: false,
  shareImage: null,
};

export const VOTE_ACTIONS = {
  up: "up",
  down: "down",
};

export const ENGLISH_LEVELS = {
  NONE: "none",
  BEGINNER: "beginner",
  INTERMEDIATE: "intermediate",
  ADVANCED: "advanced",
  FLUENT: "fluent",
  NATIVE: "native",
};

export const ENGLISH_LEVELS_OPTIONS = [
  { value: "none", label: "Ninguno" },
  { value: "beginner", label: "Principiante" },
  { value: "intermediate", label: "Intermedio" },
  { value: "advanced", label: "Avanzado" },
  { value: "fluent", label: "Con Fluidez" },
  { value: "native", label: "Nativo" },
];

export const SOCIAL_LINKS = {
  facebook: "https://facebook.com/codealo",
  discord: "https://discord.gg/TJAUa4UrZx",
  instagram: "https://instagram.com/codealo",
  website: "https://codealo.dev",
  twitter: "https://twitter.com/codealodev",
  podcast: "https://anchor.fm/codealo",
  thinkific: "https://codealo.thinkific.com",
  youtube:
    "https://www.youtube.com/channel/UCLdBO2AVbCohANbEtEHn1CA/videos?disable_polymer=1",
};

export const MY_ACCOUNT_PAGES = {
  PROFILE: "perfil",
  PROJECTS: "proyectos",
  SOLUTIONS: "soluciones",
  INVOICES: "facturacion",
  PORTFOLIO: "portafolio",
  SOCIAL: "redes-sociales",
  INTERESTS: "intereses",
  DEVELOPER: "developer",
};

export const DEFAULT_OG_IMG_URL =
  "https://res.cloudinary.com/codealodev/image/upload/v1627858064/website/og-codealo_e4zox7.png";

export const AMPLITUDE_EVENTS = {
  PAGE_VIEW: "page_view",
  SIGNUP_COMPLETED: "signup_completed",
  PROFILE_COMPLETED: "profile_completed",
  START_PROJECT_CLICK: "start_project_click",
  PROJECT_STARTED: "project_started",
  SOLUTION_PUBLISHED: "solution_published",
  SOCIAL_NETWORK_CLICK: "social_network_click",
  CONVERTED_TO_PAID: "converted_to_paid",
  PAYMENT_COMPLETED: "payment_completed",
  COURSE_STARTED: "course_started",
  COURSE_COMPLETED: "course_completed",
  USER_RECOMMENDS: "user_recommends",
  PROJECT_SUBSCRIPTION_CLICK: "project_subscription_click",
  PROJECT_SUBSCRIPTION: "project_subscription",
  PUBLISH_SOLUTION_FROM_PROJECT_CLICK: "publish_solution_from_project_click",
  PUBLISH_SOLUTION_FROM_PROFILE_CLICK: "publish_solution_from_profile_click",
  PUBLISH_SOLUTION_FROM_HOME_CLICK: "publish_solution_from_home_click",
  USED_HINT: "used_hint",
  SKIPPED_EXERCISE: "skipped_exercise",
  ANSWER_SUBMITTED: "answer_submitted",
  COURSE_SECTION_STARTED: "course_section_started",
  COURSE_SECTION_FINISHED: "course_section_finished",
};

export const SOCIAL_NETWORKS = [
  "Tik Tok",
  "Instagram",
  "YouTube",
  "Facebook",
  "LinkedIn",
  "Twitter",
  "Otra",
];

export const PROGRAMMING_CATEGORIES = [
  "JavaScript",
  "Python",
  "C#",
  "C++",
  "Ruby",
  "Java",
  "Solidity",
  "Front End",
  "Back End",
  "Full Stack",
  "Game Developer",
];

export const COURSE_PROGRESS_ACTIONS = {
  START_COURSE: "start_course",
  FINISH_COURSE: "finish_course",
  START_LESSON: "start_lesson",
  FINISH_LESSON: "finish_lesson",
  COMPLETED_SECTION: "completed_section",
};

export const PROFILE_SOCIALS = {
  discord: { baseUrl: "https://discord.gg/", icon: "discord" },
  twitter: { baseUrl: "https://twitter.com/", icon: "twitter" },
  facebook: { baseUrl: "https://facebook.com/", icon: "facebook" },
  linkedin: { baseUrl: "https://linkedin.com/", icon: "linkedin" },
  instagram: { baseUrl: "https://instagram.com/", icon: "instagram" },
};
